import { styled } from '@material-ui/core';

import { down } from '../../../../assets/style/breakpointHelpers';
import { domTag } from '../../../utils/styledFilter';

export const BodyContainer = styled('div')({
	width: '100%',
	height: 'auto',
	borderRadius: 5,
	background: 'var(--color-bg-primary)',
	padding: 20,
	boxSizing: 'border-box',
	display: 'flex',
	flexWrap: 'wrap',
	alignItems: 'stretch',
	justifyContent: 'center',
	[down('md')]: {
		padding: '8px 0 0',
	},
});

export const FilterItemContainer = styled(domTag('div', ['hide']))(({ hide }: { hide: 'true' | 'false' }) => ({
	'boxSizing': 'border-box',
	'cursor': 'pointer',
	'transition': '.1s ease',
	'display': hide === 'true' ? 'none' : 'flex',
	'color': 'var(--color-text-primary)',
	'&:hover': {
		background: 'var(--color-brand-primary-light)',
		color: 'var(--color-brand-primary)',
	},
}));

export const InputFile = styled('input')({
	zIndex: 10,
	top: 0,
	left: 0,
});

export const CreateAgentForm = styled('form')({
	display: 'flex',
	flexDirection: 'column',
	maxWidth: '90%',
	width: 1280,
	borderRadius: '3px',
	margin: '0 auto',
	marginTop: 10,
	boxSizing: 'border-box',
	[down('md')]: {
		marginTop: 12,
		maxWidth: '100%',
		width: '100%',
	},
});

export const ProfileUserSection = styled('div')({
	width: '100%',
	maxWidth: '1100px',
	height: 'auto',
	padding: '48px 56px',
	marginTop: 30,
	boxSizing: 'border-box',
	borderRadius: 5,
	margin: 'auto',
	boxShadow: 'var(--shadow-lg)',
	backgroundColor: 'var(--color-bg-elevated)',
	display: 'flex',
	flexDirection: 'column',
	gap: 32,
	overflow: 'hidden',
	[down('md')]: {
		padding: '24px 18px',
		marginTop: 12,
		borderRadius: 0,
		gap: 20,
	},
});

export const ProfileHeaderSection = styled('div')({
	'display': 'flex',
	'flexDirection': 'column',
	'gap': '0.5rem',
	'textAlign': 'center',

	'& h3': {
		fontFamily: 'var(--font-family-semibold)',
		fontSize: 'var(--text-h3-size)',
		lineHeight: 'var(--leading-tight)',
		color: 'var(--color-text-primary)',
		marginBottom: 0,
	},

	'& p': {
		fontFamily: 'var(--font-family-regular)',
		color: 'var(--color-text-tertiary)',
		fontSize: 'var(--text-body-sm-size)',
		lineHeight: 'var(--leading-relaxed)',
	},
	'& span': {
		fontFamily: 'var(--font-family-regular)',
		color: 'var(--color-text-secondary)',
		fontSize: 'var(--text-caption-size)',
		lineHeight: 'var(--leading-normal)',
	},
});

export const ProfileFormSection = styled('div')({
	display: 'grid',
	gridTemplateColumns: 'repeat(2, 1fr)',
	gap: '24px 32px',
	[down('md')]: {
		gridTemplateColumns: '1fr',
	},
});

export const FieldReadinessSection = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '1rem',
});

export const FieldReadinessItemWrapper = styled('div')({
	'display': 'flex',
	'alignItems': 'center',
	'gap': '2rem',
	'border': '1px solid var(--color-border-default)',
	'borderRadius': 10,
	'boxSizing': 'border-box',
	'padding': '20px',
	'backgroundColor': 'var(--color-bg-secondary)',
	'& .content': {
		flex: 'auto',
	},
	'& h5': {
		fontFamily: 'var(--font-family-medium)',
		fontSize: 'var(--text-body-size)',
		lineHeight: 'var(--leading-snug)',
		margin: 0,
		padding: 0,
		marginBottom: 5,
		color: 'var(--color-text-primary)',
	},
	'& p': {
		fontFamily: 'var(--font-family-regular)',
		fontSize: 'var(--text-body-sm-size)',
		lineHeight: 'var(--leading-normal)',
		margin: 0,
		padding: 0,
		color: 'var(--color-text-tertiary)',
	},
});

export const CTASection = styled('div')({
	'display': 'flex',
	'flexDirection': 'row',
	'gap': '1rem',
	'alignItems': 'center',
	'justifyContent': 'space-between',
	'marginTop': '2rem',

	'& button': {
		flex: 1,
		minHeight: '52px',
		borderRadius: '8px',
		fontWeight: 500,
		fontSize: 'var(--text-body-size)',
		transition: 'all 0.2s ease',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '0.5rem',
	},

	'& .prevbtn': {
		'color': 'var(--color-text-secondary)',
		'background': 'transparent',
		'border': '1px solid var(--color-border-default)',
		'&:hover': {
			background: 'var(--color-bg-secondary)',
			borderColor: 'var(--color-text-tertiary)',
		},
	},

	'& .nextbtn': {
		'background': 'var(--color-brand-primary)',
		'color': '#fff',
		'border': 'none',
		'&:hover:not(:disabled)': {
			background: 'var(--color-brand-primary-dark, #16a34a)',
			transform: 'translateY(-1px)',
			boxShadow: '0 4px 12px rgba(34, 197, 94, 0.3)',
		},
		'&:active:not(:disabled)': {
			transform: 'translateY(0)',
		},
	},

	[down('md')]: {
		'position': 'sticky',
		'bottom': 0,
		'backgroundColor': 'var(--color-bg-elevated)',
		'padding': '16px 0',
		'marginTop': '16px',
		'borderTop': '1px solid var(--color-border-subtle)',
		'zIndex': 10,
		'flexDirection': 'column-reverse',
		'& button': {
			width: '100%',
		},
	},

	[down('sm')]: {
		'flexDirection': 'column-reverse',
		'& button': {
			width: '100%',
		},
	},
});

export const BodySection = styled('div')({
	width: '100%',
	maxWidth: '850px',
	height: 'auto',
	margin: 0,
	textAlign: 'center',
	position: 'relative',
	border: '1px solid',
	[down('md')]: {
		width: '100%',
		margin: '20px 0 0',
	},
});

export const BodySectionComponent = styled(domTag('div', ['noborder']))(({ noborder }: { noborder?: 'true' | 'false' }) => ({
	width: '100%',
	height: '100%',
	border: noborder === 'true' ? 'none' : '1px solid var(--color-brand-primary-light)',
	borderRadius: 5,
	padding: 30,
	boxSizing: 'border-box',
	display: 'flex',
	transition: '.2s ease',
	[down('md')]: {
		padding: '15px 0',
		maxWidth: 400,
		margin: '0 auto',
	},
}));

export const ProfileImageSection = styled('img')({
	maxWidth: 270,
	maxHeight: 270,
	objectFit: 'contain',
	width: '100%',
	height: '100%',
	margin: '0 auto',
});

export const ProgressComponent = styled('div')({
	display: 'flex',
	margin: 'auto',
	borderBottom: '1px solid var(--color-border-subtle)',
	justifyContent: 'center',
	gap: '24px',
	padding: '16px 0',
});

export const ProgressComponentChild = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '16px',
});

export const ProgressComponentChildItem = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '10px',
	[down('md')]: {
		'& .label': {
			display: 'none',
		},
	},
});

export const ProgressComponentChildItemNumber = styled('div')({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '30px',
});

export const SummaryHeader = styled('div')({
	'display': 'flex',
	'alignItems': 'center',
	'justifyContent': 'center',
	'gap': '35px',
	'marginBottom': 25,
	'& .header': {
		fontFamily: 'var(--font-family-semibold)',
		fontSize: 'var(--text-body-sm-size)',
		lineHeight: 'var(--leading-normal)',
		color: 'var(--color-success)',
		textTransform: 'uppercase',
		margin: 0,
		letterSpacing: 'var(--tracking-wide)',
	},
	'& .link': {
		fontFamily: 'var(--font-family-regular)',
		fontSize: 'var(--text-caption-size)',
		lineHeight: 'var(--leading-normal)',
		color: 'var(--color-text-tertiary)',
		margin: 0,
		letterSpacing: 'var(--tracking-wide)',
		textDecoration: 'underline',
		cursor: 'pointer',
	},
});

export const SummarySection = styled('div')({
	display: 'grid',
	gridTemplateColumns: 'repeat(auto-fit, minmax(40%, 1fr))',
	gap: '2rem',
	border: '1px solid var(--color-border-default)',
	padding: 30,
	borderRadius: 7,
	backgroundColor: 'var(--color-bg-secondary)',
	[down('md')]: {
		gridTemplateColumns: 'repeat(auto-fit, minmax(100%, 1fr))',
	},
});

export const SummaryContainer = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '3rem',
});

export const CardSection = styled('div')({
	'display': 'flex',
	'flexDirection': 'column',
	'gap': '5px',
	'& .label': {
		fontFamily: 'var(--font-family-medium)',
		fontSize: 'var(--type-xs)',
		lineHeight: 'var(--leading-normal)',
		color: 'var(--color-text-tertiary)',
		textTransform: 'uppercase',
		margin: 0,
		letterSpacing: 'var(--tracking-wider)',
	},
	'& .value': {
		fontFamily: 'var(--font-family-regular)',
		fontSize: 'var(--text-body-size)',
		lineHeight: 'var(--leading-normal)',
		margin: 0,
		color: 'var(--color-text-secondary)',
	},
});

// Circular avatar upload - centers at top of form
export const AvatarUploadSection = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gridColumn: '1 / -1',
	marginBottom: '16px',
});

export const AvatarUploadWrapper = styled('div')({
	'position': 'relative',
	'width': '140px',
	'height': '140px',
	'borderRadius': '50%',
	'overflow': 'hidden',
	'border': '3px solid var(--color-border-default)',
	'backgroundColor': 'var(--color-bg-secondary)',
	'cursor': 'pointer',
	'transition': 'all 0.2s ease',

	'&:hover': {
		borderColor: 'var(--color-brand-primary)',
		transform: 'scale(1.02)',
	},

	'& img': {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
		animation: 'photoFadeIn 0.3s ease-out',
	},

	'& input[type="file"]': {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		opacity: 0,
		cursor: 'pointer',
		zIndex: 2,
	},

	[down('md')]: {
		width: '170px',
		height: '170px',
	},
});

export const AvatarPlaceholder = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	height: '100%',
	color: 'var(--color-text-tertiary)',
	gap: '4px',
});

export const AvatarOverlay = styled('div')({
	position: 'absolute',
	bottom: 0,
	left: 0,
	right: 0,
	height: '40px',
	background: 'rgba(0, 0, 0, 0.6)',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: '#fff',
	fontSize: '12px',
	fontFamily: 'var(--font-family-medium)',
});

export const AvatarLabel = styled('p')({
	fontFamily: 'var(--font-family-medium)',
	fontSize: 'var(--text-label-size)',
	color: 'var(--color-text-secondary)',
	marginTop: '12px',
	marginBottom: 0,
});

// Full-width field wrapper (for Voter ID)
export const FullWidthField = styled('div')({
	gridColumn: '1 / -1',
});

// Read-only avatar display for Summary page
export const SummaryAvatarSection = styled('div')({
	display: 'flex',
	justifyContent: 'center',
	marginBottom: '24px',
});

export const SummaryAvatarWrapper = styled('div')({
	'width': '100px',
	'height': '100px',
	'borderRadius': '50%',
	'overflow': 'hidden',
	'border': '3px solid var(--color-brand-primary)',
	'backgroundColor': 'var(--color-bg-secondary)',
	'boxShadow': '0 4px 12px rgba(0, 0, 0, 0.1)',

	'& img': {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
	},
});

// Enhanced Terms & Conditions section
export const TermsContainer = styled('div')({
	'display': 'flex',
	'alignItems': 'flex-start',
	'gap': '12px',
	'padding': '16px 20px',
	'backgroundColor': 'var(--color-bg-secondary)',
	'border': '1px solid var(--color-border-default)',
	'borderRadius': '8px',
	'marginTop': '1.5rem',
	'marginBottom': '1rem',
	'transition': 'border-color 0.2s ease',

	'&:has(input:checked)': {
		borderColor: 'var(--color-brand-primary)',
	},
});

export const TermsText = styled('p')({
	'fontFamily': 'var(--font-family-regular)',
	'fontSize': 'var(--text-body-sm-size)',
	'lineHeight': 'var(--leading-relaxed)',
	'color': 'var(--color-text-secondary)',
	'margin': 0,

	'& a': {
		color: 'var(--color-brand-primary)',
		textDecoration: 'underline',
		fontFamily: 'var(--font-family-medium)',
	},
});

// Social Media Section Styles
export const SocialMediaSection = styled('div')({
	gridColumn: '1 / -1',
	marginTop: '16px',
	paddingTop: '24px',
	borderTop: '1px solid var(--color-border-subtle)',
});

export const SectionHeader = styled('div')({
	'display': 'flex',
	'alignItems': 'center',
	'gap': '8px',
	'marginBottom': '20px',
	'minHeight': '44px',
	'padding': '6px 0',

	'& h4': {
		fontFamily: 'var(--font-family-medium)',
		fontSize: 'var(--text-body-size)',
		lineHeight: 'var(--leading-normal)',
		color: 'var(--color-text-primary)',
		margin: 0,
	},

	'& span': {
		fontFamily: 'var(--font-family-regular)',
		fontSize: 'var(--text-body-sm-size)',
		color: 'var(--color-text-tertiary)',
	},
});

export const SocialMediaGrid = styled('div')({
	display: 'grid',
	gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
	gap: '16px',
	[down('md')]: {
		gridTemplateColumns: 'minmax(0, 1fr)',
	},
});

// Messaging Checkboxes Container (below phone number)
export const MessagingCheckboxContainer = styled('div')({
	// Stack "Connected to:" over the options so the two rows align in a clean
	// left column instead of wrapping unevenly beside the label.
	'display': 'flex',
	'flexDirection': 'column',
	'alignItems': 'flex-start',
	'gap': '2px',
	'marginTop': '10px',

	'& > span': {
		marginBottom: '2px',
		fontFamily: 'var(--font-family-regular)',
		fontSize: 'var(--text-body-sm-size)',
		color: 'var(--color-text-tertiary)',
	},
});

// Wrapper for phone number field with messaging checkboxes
export const PhoneFieldWrapper = styled('div')({
	display: 'flex',
	flexDirection: 'column',
});

// Icon wrapper for social media icons
export const SocialIconWrapper = styled('span')({
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '16px',
	height: '16px',
	flexShrink: 0,
});

// Messaging checkbox with icon
export const MessagingCheckboxLabel = styled('div')({
	// No left padding so the icon column lines up flush under "Connected to:".
	'display': 'flex',
	'alignItems': 'center',
	'gap': '8px',
	'minHeight': '40px',
	'padding': '2px 0',

	'& svg': {
		width: '16px',
		height: '16px',
		flexShrink: 0,
	},
});

// Voter Card Document Upload Section
export const VoterCardUploadWrapper = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
});

export const VoterCardUploadLabel = styled('label')({
	fontSize: '12px',
	color: 'var(--color-text-secondary)',
	marginBottom: '8px',
	fontFamily: 'var(--font-family-medium)',
});

export const VoterCardDropzone = styled(domTag('div', ['hasFile', 'hasError']))(
	({ hasFile, hasError }: { hasFile?: boolean; hasError?: boolean }) => ({
		'position': 'relative',
		'display': 'flex',
		'flexDirection': 'column',
		'alignItems': 'center',
		'justifyContent': 'center',
		'padding': hasFile ? '12px' : '20px',
		'minHeight': hasFile ? '80px' : '120px',
		'border': `2px dashed ${hasError ? 'var(--color-error)' : hasFile ? 'var(--color-brand-primary)' : 'var(--color-border-default)'}`,
		'borderRadius': '8px',
		'backgroundColor': hasFile ? 'var(--color-brand-primary-light)' : 'var(--color-bg-secondary)',
		'cursor': 'pointer',
		'transition': 'all 0.2s ease',

		'&:hover': {
			borderColor: hasError ? 'var(--color-error)' : 'var(--color-brand-primary)',
			backgroundColor: 'var(--color-brand-primary-light)',
		},
	})
);

export const VoterCardDropzoneContent = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '8px',
	textAlign: 'center',
	pointerEvents: 'none',
});

export const VoterCardDropzoneText = styled('p')({
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-body-sm-size)',
	color: 'var(--color-text-secondary)',
	margin: 0,
});

export const VoterCardDropzoneHint = styled('span')({
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-caption-size)',
	color: 'var(--color-text-tertiary)',
});

export const VoterCardFilePreview = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '12px',
	width: '100%',
	pointerEvents: 'none',
});

export const VoterCardFileInfo = styled('div')({
	flex: 1,
	overflow: 'hidden',
});

export const VoterCardFileName = styled('p')({
	fontFamily: 'var(--font-family-medium)',
	fontSize: 'var(--text-body-sm-size)',
	color: 'var(--color-text-primary)',
	margin: 0,
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

export const VoterCardFileSize = styled('span')({
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-caption-size)',
	color: 'var(--color-text-tertiary)',
});

export const VoterCardRemoveButton = styled('button')({
	'display': 'flex',
	'alignItems': 'center',
	'justifyContent': 'center',
	'width': '28px',
	'height': '28px',
	'borderRadius': '50%',
	'border': 'none',
	'backgroundColor': 'var(--color-bg-tertiary)',
	'color': 'var(--color-text-secondary)',
	'cursor': 'pointer',
	'transition': 'all 0.2s ease',
	'pointerEvents': 'auto',
	'zIndex': 10,

	'&:hover': {
		backgroundColor: 'var(--color-error)',
		color: '#fff',
	},
});

export const VoterCardErrorText = styled('p')({
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-caption-size)',
	color: 'var(--color-error)',
	margin: '4px 0 0',
});

// Photo upload action sheet (mobile camera/gallery picker)
export const PhotoActionSheet = styled('div')({
	display: 'flex',
	gap: '12px',
	marginTop: '12px',
	justifyContent: 'center',
});

export const PhotoActionButton = styled('button')({
	'display': 'flex',
	'flexDirection': 'column',
	'alignItems': 'center',
	'gap': '6px',
	'padding': '12px 20px',
	'borderRadius': '12px',
	'border': '1px solid var(--color-border-default)',
	'backgroundColor': 'var(--color-bg-secondary)',
	'color': 'var(--color-text-secondary)',
	'cursor': 'pointer',
	'fontFamily': 'var(--font-family-medium)',
	'fontSize': 'var(--text-caption-size)',
	'transition': 'all 0.2s ease',
	'minWidth': '100px',
	'minHeight': '44px',

	'&:hover': {
		borderColor: 'var(--color-brand-primary)',
		color: 'var(--color-brand-primary)',
		backgroundColor: 'var(--color-brand-primary-light)',
	},

	'&:active': {
		transform: 'scale(0.97)',
	},
});

// Voter card mobile action buttons (camera/file picker)
export const VoterCardActionButtons = styled('div')({
	display: 'flex',
	gap: '12px',
	justifyContent: 'center',
	width: '100%',
});

export const VoterCardActionButton = styled('button')({
	'display': 'flex',
	'alignItems': 'center',
	'gap': '8px',
	'padding': '10px 16px',
	'borderRadius': '8px',
	'border': '1px solid var(--color-border-default)',
	'backgroundColor': 'var(--color-bg-primary)',
	'color': 'var(--color-text-secondary)',
	'cursor': 'pointer',
	'fontFamily': 'var(--font-family-medium)',
	'fontSize': 'var(--text-body-sm-size)',
	'transition': 'all 0.2s ease',
	'minHeight': '44px',

	'&:hover': {
		borderColor: 'var(--color-brand-primary)',
		color: 'var(--color-brand-primary)',
	},

	'&:active': {
		transform: 'scale(0.97)',
	},
});

// Chevron icon for collapsible sections
export const ChevronIcon = styled(domTag('span', ['isExpanded']))(({ isExpanded }: { isExpanded: boolean }) => ({
	display: 'inline-flex',
	transition: 'transform 0.2s ease',
	transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
	color: 'var(--color-text-tertiary)',
}));

// =============================================================================
// Editorial credentialing layout (introduced with the KYC integration)
// =============================================================================

export const PageEyebrow = styled('p')({
	margin: 0,
	fontFamily: 'var(--font-family-medium)',
	fontSize: '11px',
	letterSpacing: 'var(--tracking-widest)',
	textTransform: 'uppercase',
	color: 'var(--color-brand-primary)',
});

export const PageTitle = styled('h2')({
	margin: 0,
	fontFamily: 'var(--font-family-display)',
	fontSize: '32px',
	lineHeight: 1.15,
	color: 'var(--color-text-primary)',
	[down('md')]: {
		fontSize: '26px',
	},
	[down('sm')]: {
		fontSize: '22px',
		lineHeight: 1.2,
	},
});

export const PageSubtitle = styled('p')({
	margin: 0,
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-body-size)',
	lineHeight: 1.55,
	color: 'var(--color-text-secondary)',
	maxWidth: '60ch',
});

export const PageHeaderBlock = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
	textAlign: 'left',
	[down('md')]: {
		gap: '6px',
		// Keep the page eyebrow + title visible while the user scrolls a long
		// step on mobile. Backdrop blur softens the content sliding behind it.
		position: 'sticky',
		top: 0,
		zIndex: 5,
		backgroundColor: 'color-mix(in srgb, var(--color-bg-elevated) 92%, transparent)',
		backdropFilter: 'blur(10px)',
		WebkitBackdropFilter: 'blur(10px)',
		paddingTop: 12,
		paddingBottom: 8,
		marginInline: -18,
		paddingInline: 18,
	},
});

// Two-column desktop layout: verification card on the left (sticky), form fields on the right.
// On phones (≤md) we collapse to single column; tablet portrait (768–959 px) keeps the
// desktop two-column layout but with a tighter left column so iPads don't waste horizontal
// room with single-column forms.
//
// `minmax(0, 1fr)` (instead of plain `1fr`) prevents grid columns from inflating to fit
// long child content when the natural min-content exceeds the parent width. Without this,
// a child set to `width: 100%` can push the column past the grid container on narrow phones.
export const BasicInfoLayout = styled('div')({
	'display': 'grid',
	'gridTemplateColumns': 'minmax(320px, 380px) minmax(0, 1fr)',
	'gap': '32px',
	'alignItems': 'flex-start',
	'width': '100%',
	'minWidth': 0,
	// Phones (anything below tablet portrait) — single column.
	[down('md')]: {
		gridTemplateColumns: 'minmax(0, 1fr)',
		gap: '20px',
	},
	// Tablet portrait override — restore the 2-col layout with a tighter left column.
	'@media (min-width: 768px) and (max-width: 959px)': {
		gridTemplateColumns: 'minmax(280px, 320px) minmax(0, 1fr)',
		gap: '24px',
	},
});

export const StickyVerificationColumn = styled('div')({
	position: 'sticky',
	top: '24px',
	[down('md')]: {
		position: 'static',
	},
});

export const FieldsColumn = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '28px',
});

export const FieldsSection = styled('section')({
	display: 'flex',
	flexDirection: 'column',
	gap: '14px',
});

export const FieldsSectionEyebrow = styled('p')({
	margin: 0,
	fontFamily: 'var(--font-family-semibold)',
	fontSize: '11px',
	letterSpacing: 'var(--tracking-widest)',
	textTransform: 'uppercase',
	color: 'var(--color-text-tertiary)',
});

export const FieldsSectionGrid = styled('div')({
	display: 'grid',
	gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
	gap: '16px 20px',
	[down('md')]: {
		gridTemplateColumns: '1fr',
		gap: '14px',
	},
});

export const VerifiedFieldRow = styled('div')({
	display: 'grid',
	gridTemplateColumns: 'minmax(0, 1fr) auto',
	gap: '8px',
	alignItems: 'flex-end',
	[down('sm')]: {
		gridTemplateColumns: 'minmax(0, 1fr)',
	},
});

export const DuplicateStatusChip = styled(domTag('button', ['tone']))(
	({ tone }: { tone: 'checking' | 'passed' | 'duplicate' }) => ({
		display: 'inline-flex',
		alignItems: 'center',
		gap: '8px',
		padding: '10px 14px',
		minHeight: '44px',
		maxWidth: '100%',
		border: 'none',
		borderRadius: '999px',
		fontSize: '12px',
		fontFamily: 'var(--font-family-semibold)',
		letterSpacing: 'var(--tracking-wide)',
		lineHeight: 1.3,
		textAlign: 'left',
		cursor: tone === 'duplicate' ? 'pointer' : 'default',
		color:
			tone === 'passed'
				? 'var(--color-success-text)'
				: tone === 'duplicate'
					? 'var(--color-error-text)'
					: 'var(--color-text-secondary)',
		backgroundColor:
			tone === 'passed' ? 'var(--color-success-bg)' : tone === 'duplicate' ? 'var(--color-error-bg)' : 'var(--color-bg-tertiary)',
	})
);

export const VerifiedBadgeInline = styled(domTag('span', ['tone']))(({ tone }: { tone: 'success' | 'warning' | 'idle' }) => ({
	display: 'inline-flex',
	alignItems: 'center',
	gap: '6px',
	padding: '8px 12px',
	borderRadius: '999px',
	fontSize: '11px',
	fontFamily: 'var(--font-family-semibold)',
	letterSpacing: 'var(--tracking-wide)',
	height: '40px',
	whiteSpace: 'nowrap',
	color:
		tone === 'success'
			? 'var(--color-success-text)'
			: tone === 'warning'
				? 'var(--color-warning-text)'
				: 'var(--color-text-tertiary)',
	backgroundColor:
		tone === 'success' ? 'var(--color-success-bg)' : tone === 'warning' ? 'var(--color-warning-bg)' : 'var(--color-bg-tertiary)',
}));
